actionFlag = false;
actionFlag_timer = 300;	
function actionFlagUp(){actionFlag = true; setTimeout(function(){ actionFlag = false;}, actionFlag_timer);}

$(document).ready(function(){
	fixUI();

	var secureUrl = $("meta[property=':secureUrl']").attr("content");
	/*
	$(".openLoginBox").bind('touchstart click', function(){
	  if (!flag) { flag = true;
		    setTimeout(function(){ flag = false; }, flag_timer);	

			var loginUrl = secureUrl + "/member";

	         var left = (screen.width/2)-(400/2);
	         var top = (screen.height/2)-(550/2);
	        popupChildWindow = window.open(loginUrl, 'popup', 'status=1, resizable=0, width=400, height=550 top=' + top +', left='+ left +' ');
		
	        popupTimer = setInterval('popupPolling()', 1000);
		}
	});
	*/

	
	$("#btn_fastWrite").bind('touchstart click', function(){if (!actionFlag) {actionFlagUp();	
		$("#fastWriterModal").modal('show');
	}});		
	

	
	$("#btnLeft").bind('touchstart click', function(){if (!actionFlag) {actionFlagUp();

			$( "#leftSidebar" ).animate({
			    'left': "0px",
			  },260);
		  
			$("#dismiss").toggleClass("leftToggled");		  
			$("#dismiss").fadeIn(250);
			$("#uiBlock").fadeIn(250);
		}});

	/***** Open Search Bar *****/
	$("#btnRight").bind('touchstart click', function(){if (!actionFlag) {actionFlagUp();

			$("#headerSearchBox").css('display','block');
			$("#dismiss").toggleClass("searchBarToggled");
			$("#dismiss").fadeIn(250);			
			$("#uiBlock").fadeIn(250);
		}});
	
	$("#btn_search").bind('touchstart click', function(){
		if (!actionFlag) {actionFlagUp();

			$("#headerSearchBox").css('display','block');
			$("#dismiss").toggleClass("searchBarToggled");
			$("#dismiss").fadeIn(250);			
			$("#uiBlock").fadeIn(250);
		}
	});
	
	
	/***** Go Search *****/
	$("#btn_goSearch").bind('touchstart click', function(){
		if (!actionFlag) {actionFlagUp();
	  		var searchText = $("#input-search").val();
	  		if(searchText != ""){
		  		window.location.href = '/search/' + searchText;	
	  		}else{
		  		alert('Please insert search key.');
	  		}
	  		
	  		
		}
	});
	
	$("#input-search").keypress(function( event ) {
	  if ( event.which == 13 ) {
	    $("#btn_goSearch").click();
	  }
	
	});
	
	$("#dismiss").bind('touchstart click', function(){if (!actionFlag) {actionFlagUp();
		dismiss();

	}});

	$(".chEdition").bind('touchstart click', function(){if (!actionFlag) {actionFlagUp();
		$("#changeEditionModal").modal('show');
		dismiss();
		$("#changeEditionModal").on('hidden.bs.modal', function () {
			fixUI();
		});		
	}});	
	/*
	$(".btn_menuBox").bind('touchstart click', function(){
		if (!actionFlag) {actionFlagUp();
	  		
	  		var menu_id = this.id.replace('btn_menuBox_','');
	  		
	  		$(".btn_menuBox").css("background-color","");
	  		$(".btn_menuBox").css("color","");
	  			  		
	  		$(this).css('background-color','#e0e0e0');		 		  		
	  		$(this).css('color','#1a1a1a');  		  			  		
	  			  		
	  		$(".parentMenuBox").slideUp(200);
	  		$(".childrenNavi").slideUp(200);	  		
	  		$("#parentMenuBox_" + menu_id).slideDown(200);
		}		
		
	});
	*/
	$("#leftSidebar .parentNavi a").bind('touchstart click', function(e){if (!actionFlag) {actionFlagUp();
		
	  		var target = $(this).attr("data-child-menu");
	  		var targetState = $("#child_" + target).css('display');

	  		if(targetState == "block"){
		  		$(this).css('color','');		  		
		  		$("#child_" + target).slideUp(250);
	  		}else{
		  		$("#leftSidebar .parentNavi").css('color','');		 		  		
		  		$(this).css('color','#0073aa');  		
		  		$(".childNavi").slideUp(50);		
		  		$("#child_" + target).slideDown(250);		  		
	  		}

		}		
		
	});


	$("#leftSidebar .childNavi a").bind('touchstart click', function(){
		event.preventDefault();			
		if (!actionFlag) {actionFlagUp();		
			var target = $(this).attr('href');
			window.location = target;
		}
	});

	$("#header_wrapper").bind('mouseleave',function(){
		$(".childrenNavi").slideUp(200);
		$(".parentMenuBox").slideUp(200);	
  		//$(".btn_menuBox").css("background-color","");
  		//$(".btn_menuBox").css("color","");			
	});

	$("#menuBox .parentNavi").bind('touchstart click', function(){
		if (!actionFlag) {actionFlagUp();
	  		
	  		var target = $(this).attr("data-child-menu");
	  		
	  		var targetState = $("#child_" + target).css('display');
	  		if(targetState == "block"){
		  		$("#child_" + target).slideUp(100);
	  		}else{
		  		$(".childNavi").slideUp(100);		  		
		  		$("#child_" + target).delay(100).slideDown(200);		  		
	  		}

		}		
		
	}).mouseenter(function(){
		console.log("test");
		$("#menuBox .parentNavi").css('color','');
		$("#menuBox .parentNavi").css('background-color','');		
		
		//$(this).css('color','#eaeaea');
		//$(this).css('background-color','#212a34');
		var target = $(this).attr('data-child-menu');
		console.log(target);
		$(".childrenNavi").slideUp(200);		
		$("#menuBox #childrendMenuBox_" + target).slideDown(200);
				
	});
	
	$(".openContentModal").bind('touchstart click', function(){ if (!actionFlag) {actionFlagUp();
		var type = $(this).attr('data-content-type');
		switch(type){
			case "page":
				$("#contentModal .infoBox").hide();
				$("#contentModal .contentBox").css("width","100%");
				$("#contentModal .contentBox").css("border","0px");
				History.pushState('','' ,"https://www.tutorialbook.club/");		
			break;
			
			case "post":
				$("#contentModal .contentBox").css("width","");				
				$("#contentModal .infoBox").show();
				
			break;
			
		}
		
		$("#contentModal").modal('show');
		
		$("#contentModal").on('hidden.bs.modal', function () {
			//History.back();
			/*
			$("#comment .loading").show();
			var service_url = window.location.href;
			$(".fb-comments").attr("data-href",service_url);
			FB.XFBML.parse(document, function(){
				$("#comment .loading").hide();
			});
			*/			
		});		
		
	}});
	
	$(".chLang").bind('touchstart click', function(){if (!actionFlag) {actionFlagUp();		
		var lang = $(this).attr('data-lang');
		var token  = getToken();
						
		var data = {_csrf:token, lang:lang}
		
		$.ajax({
	        url: '/util/chlang',
	        data: data,
	        type: 'POST',
	        dataType: 'JSON',
	        success: function(result){
				if(result['code'] == 100){
					location.reload();
				}else{
					alert("Sorry Something wrong.");
				}
	        },//Success
			error: function(request,status,error){
				alert("Sorry Something wrong.");
			}	
		});		
	}});// END $('.chLang')	
	
}); // END READY

$(window).resize(function(){

	fixUI();

});

$(window).scroll(function(){
	/*
	var currPos = $(this).scrollTop();
	var headerPos = $("#header .wide").position().top;
	var headerHeight = $("#header .wide").height();
	var headerBottom = headerPos + headerHeight;
	var windowWidth = $(window).width();

	if(windowWidth > 795){
		if(currPos > headerBottom){
			$("#header .wide").css("display",'');
			$("#header .narrow").fadeIn(300)
		}else{
			//$("#header_wide").css("display",'block');	
			$("#header .wide").fadeIn(300);							
			$("#header .narrow").css("display",'');			
		}			
	}else{
			$("#header .wide").css("display",'');				
			$("#header .narrow").css("display",'');					
	}		
	*/
});

function dismiss(){
	$( "#leftSidebar" ).animate({
	    'left': "-260px",
	  },260);
	$("#headerSearchBox").css('display','');			  
	$("#dismiss").removeClass("leftToggled");		
	$("#dismiss").removeClass("searchBarToggled");	  
	$("#dismiss").fadeOut(250);
	$("#uiBlock").fadeOut(250);
}

function fixUI(){
	var windowWidth = $(window).width();
	var leftPx = "260px";
	var responsive_lv1 = 852;
	var responsive_lv2 = 1202;
	if(windowWidth < responsive_lv1){
			$("#header_wide").css("display",'');				
			$("#header_narrow").css("display",'');					
	}

}

function getToken(){
	return $("meta[property='token']").attr("content");
}

function getLang(){
	return $("meta[property='userlang']").attr("content");		
}

function getMediaUrl(){
	return $("meta[property='mediaUrl']").attr("content");
}

function ChangeUrl(page, url) {
    if (typeof (history.pushState) != "undefined") {
        var obj = { Page: page, Url: url };
        history.pushState(obj, obj.Page, obj.Url);
    } else {
        console.log("Browser does not support HTML5.");
    }
}

function fixWideSearchBar(){
	/*
	console.log($("#memberBox").outerWidth());
	var exceptWidth = $("#logoBox").outerWidth() + $("#header_wide_leftBox").outerWidth() + $("#header_wide_rightBox").outerWidth()+ 10;
	var searchBarWidth = $(window).width() - exceptWidth;
	$("#wide_searchBox").width(searchBarWidth);	
	*/
}


function toggleSearchBar(){
	
}

function toggleLeftSideBar(){
	
}

function popupPolling() {
    if(popupChildWindow && popupChildWindow.closed) {
        // The popup has been closed, stop the timer and reload window.
        clearInterval(popupTimer);
        location.reload();
    }
}